
import createIconComponent from '../utils/createIconComponent';
import { SVG_AMEX } from '../../../dist';
import React from 'react';
const AmexIcon = createIconComponent({ content: SVG_AMEX, height: 24, width: 24 });
AmexIcon.displayName = 'AmexIcon';
export default AmexIcon;
